export const mentorInfo = [
  {
    id: 0,
    name: "Dr. Drew Endy",
    role: "Principle Investigator",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/drendy.png",
      alt: "Photo of Dr. Drew Endy",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/drewfunny.jpg",
      alt: "Fun Photo of Dr. Drew Endy",
    },
    website: "", 
    email: "", 
    linkedin: "",
    twitter: "", 
    google: "", 
    bio: "Dr. Drew Endy is a pioneer in the synthetic biology field and lecturer at Stanford University. Dr. Endy was heavily involved in launching new undergraduate majors in Bioengineering at Stanford and MIT, where he also assisted in the creation of iGEM. Passionate about biosafety and security, Dr. Endy has served on the US National Science Advisory Board for Biosecurity (NSABB), the Committee on Science Technology & Law (CSTL), the International Union for the Conservation of Nature’s (IUCN) Synthetic Biology Task Force, the World Health Organization’s (WHO) Advisory Committee on Variola Virus Research, and, briefly, the Pentagon’s Defense Innovation Board (DIB). Fun Fact: Dr. Endy was featured as one of the 75 most influential people of the 21st century in the Esquire magazine!",
  },
  {
    id: 1,
    name: "Dr. Huijun Ring",
    role: "Mentor",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/drring.png",
      alt: "Photo of Dr. Huijun Ring",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/ringfunny.jpg",
      alt: "Fun Photo of Dr. Huijun Ring",
    },
    website: "", 
    email: "", 
    linkedin: "",
    twitter: "", 
    google: "", 
    bio: "Dr. Huijin Ring is a board-certified clinical molecular geneticist and an adjunct professor at Stanford’s Department of Medicine. Dr. Ring received her PhD in molecular biology and genetics from Cornell University and completed her post-doctoral at Stanford University School of Medicine. Currently, she conducts research in genomic medicine and East-West integrative health, and teaches courses at Stanford University. In addition to mentoring iGEM, she also mentors Stanford Graduate School of Business students, Knight-Hennessy Scholars, and junior women faculty in science and medicine. Fun Fact: Dr. Ring is an experienced biotech entrepreneur and executive! She previously worked at Incyte Pharmaceuticals and DNA Direct in Silicon Valley, and also founded iDNA Inc., a precision medicine company that was named one of the fastest growing technology companies in China by Deloitte.",
  },
  {
    id: 2,
    name: "Dr. Phil Kyriakakis",
    role: "Mentor",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/philkyriakakis-c.jpg",
      alt: "Photo of Dr. Phil Kyriakakis",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/philfunny.jpg",
      alt: "Fun Photo of Dr. Phil Kyriakakis",
    },
    bio: "Dr. Phillip Kyriakakis is an incoming Clinical Educator Assistant Professor of Psychiatry and current Senior Research scientist in the Bioengineering Department at the Wu Tsai Institute for Neuroscience. Dr. Kyriakakis completed his undergraduate studies in Biochemistry at UMass Boston, where he worked in Dr. Alexey Veraksa's developmental biology lab and pioneered PhyB optogenetics in animal cells in 2008. He pursued further education at UC San Diego, focusing on cellular programming and metabolism within the Division of Biological Sciences. Following that, Dr. Kyriakakis conducted postdoctoral research in UC San Diego's Bioengineering Department, collaborating with Todd Coleman on the advancement of optogenetic tools and related technologies. In 2021, he transitioned to his current role as a Senior Research Scientist at Stanford University's Wu Tsai Institute for Neurosciences within the Bioengineering Department. Fun Fact: Dr. Kyriakakis has two loud cats that like to “sing” in the middle of the night!",
  },
  {
    id: 3,
    name: "Dr. Nils Averesch",
    role: "Mentor",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/draveresch.png",
      alt: "Photo of Dr. Nils Averesch",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/nilsfunny.jpg",
      alt: "Fun Photo of Dr. Nils Averesch",
    },
    bio: "Dr. Nils Averesch is a research engineer at Stanford’s Department of Civil and Environmental Engineering, and co-investigator of the NASA Center for Utilization of Biological Engineering in Space (CUBES). Previously, Nils was Synthetic Biology task-lead at NASA’s Ames Research Center in the Space Science and Astrobiology Division. He holds a PhD in Metabolic Engineering from the University of Queensland in Australia and an engineer’s degree in Biochemical Engineering, from the Technical University of Dortmund in Germany. Currently, Dr. Averesch’s research revolves around advanced biomaterials for manufacturing. Specifically, his research group designs and constructs microbial cell factories for production of high-performance bioplastics from carbon dioxide. Fun Fact: Nils has participated in a Mars analog mission at the Hawaii Space Exploration Analog and Simulation (HI-SEAS) habitat where he explored in-situ biomanufacturing in support of long-duration space-exploration during.",
  },
  {
    id: 4,
    name: "Cyrus K.",
    role: "Mentor",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/cyrus-c.jpg",
      alt: "Photo of Cyrus K.",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/cyrusfunny.png",
      alt: "Fun Photo of Cyrus K.",
    },
    bio: "Cyrus is a second-year PhD student in the Bioengineering program at Stanford. He enjoys making elegant computational tools and models that are useful for answering questions in science and engineering. In his spare time, he enjoys the process of learning new things. Fun Fact: Cyrus is currently learning swing dance!",
  },
  {
    id: 5,
    name: "Caroline Van",
    role: "Team Coordinator",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/caroline.jpg",
      alt: "Photo of Caroline Van",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/caroline2.jpg",
      alt: "Fun Photo of Caroline Van",
    },
    bio: "Caroline is a senior from Fredericksburg, VA who is double majoring in computer science and French. Previously, she studied the strain-level dynamics following fecal microbiota transplants under Dr. Benjamin Good and the directed evolution of PETases with the 2022 Stanford iGEM team. She's excited to bring her background in computational biology, web development, and finances as an iGEM coordinator. When she’s not coding away, she enjoys engaging with her heritage with the Stanford Vietnamese Student Association, dancing in Stanford Mua Lac Hong, and working at the Bridge Peer Counseling Center.",
  },
  {
    id: 6,
    name: "Gurmen Bahia",
    role: "Team Coordinator",
    img: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/gurmen.jpg",
      alt: "Photo of Gurmen",
    },
    imgFun: {
      src: "https://static.igem.wiki/teams/4951/wiki/team-photos/gurmen2.jpg",
      alt: "Fun Photo of Gurmen",
    },
    bio: "Gurmenjit Bahia (‘24) is a senior studying Biology with a concentration in biochemistry/biophysics from Modesto, CA. She particularly enjoys research revolving around omics and healthcare disparities. Additionally, she is involved with the BIOME (Biological Interdisciplinary Open Maker Environment) and a group advocating for First-generation and/or low-income students known as FLIP. She aspires to become an Orthopedic surgeon and go into global surgery, while continuing to complete research. Aside from her academics, she loves nature, gardening, and long walks. ",
  }
];
